const FavoriteTriggerApp = {
    initialize(element) {
        this.element = element
        this.isLoading = false
        this.isFavorite = false
        this.dataset = this.element.dataset

        this.handleTrigger = this.handleTrigger.bind(this)

        this.productId = this.dataset.productId
        this.addUrl = this.dataset.addUrl
        this.removeUrl = this.dataset.removeUrl
        this.refreshListing = this.element.hasAttribute('r-favorite-refresh-listing')

        this.addIcon = 'ico-heart'
        this.removeIcon = 'ico-heart-full'

        this.addText = this.dataset.addText
        this.removeText = this.dataset.removeText
        this.generalError = this.dataset.generalError

        this.icon = this.element.querySelector('.ico')
        this.text = this.element.querySelector('.is-text')
        this.thumb = this.element.closest('.js-thumb')

        if (this.element.classList.contains('is-in-favorites')) {
            this.isFavorite = true
        }

        this.element.addEventListener('click', this.handleTrigger)
        this.element.addEventListener('keypress', this.handleTrigger)
    },
    toggleAttributes() {
        this.element.classList.toggle('is-in-favorites', this.isFavorite)

        if (this.icon) {
            this.icon.classList.toggle(this.addIcon, !this.isFavorite)
            this.icon.classList.toggle(this.removeIcon, this.isFavorite)
        }

        if (this.text) {
            this.text.innerHTML = this.isFavorite ? this.removeText : this.addText
        }

        if (this.thumb) {
            this.thumb.classList.toggle('is-in-favorites', this.isFavorite)
        }
    },
    handleLoading(bool) {
        this.isLoading = bool
        this.element.classList.toggle('is-loading', bool)
    },
    handleAlert(message, type) {
        window.Eshop.alert(message, {
            type: type
        })
    },
    handleTrigger(event) {
        event.preventDefault()

        if (event.type == 'keypress' && ![13,32].includes(event.charCode))
            return

        this.handlePost(!this.isFavorite ? this.addUrl : this.removeUrl)
    },
    handlePost(url) {
        if (this.loading) return

        const token = getCookie('csrfToken')

        this.handleLoading(true)
        $.ajax({
            url: url,
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': token,
                'Accept': 'application/json, text/javascript',
                'x-requested-with': 'XMLHttpRequest',
            },
            dataType: 'json',
            success: (response) => {
                if (response.status) {
                    this.isFavorite = !this.isFavorite

                    for (const favoriteCount of document.querySelectorAll('.js-favorite-count')) {
                        favoriteCount.dataset.count = response.count
                        favoriteCount.innerHTML = response.count
                    }
                    for (const favoriteCount of document.querySelectorAll('.js-favorite-data-count')) {
                        favoriteCount.dataset.count = response.count
                    }

                    if (this.refreshListing) {
                        this.refreshCurrentListingPage()
                    }
                }

                this.handleAlert(response.message, response.status ? 'success' : 'error')
            },
            error: () => {
                this.handleAlert(this.generalError, 'error')
            },
            complete: () => {
                this.handleLoading(false)
                this.toggleAttributes()
            }
        })
    },
    refreshCurrentListingPage(tryPrevious = false) {
        let urlToFetch = window.location.href

        if (tryPrevious) {
            const pagerPrevEl = document.querySelector('.pager__list .c-btn.is-prev')

            if (!pagerPrevEl) {
                return
            }

            urlToFetch = pagerPrevEl.getAttribute('href')
        }

        for (const listingHolder of document.querySelectorAll('.listing__holder')) {
            listingHolder.classList.add('is-loading')
        }

        $.ajax({
            url: urlToFetch,
            dataType: 'json',
            success: (data) => {
                Listing.callbacks.update(data)
            },
            error: () => {
                if (!tryPrevious) {
                    this.refreshCurrentListingPage(true)
                } else {
                    this.handleAlert(this.generalError, 'error')
                }
            },
            complete: () => {
                this.handleLoading(false)
                this.toggleAttributes()
            }
        });
    }
}

function initializeFavoriteTriggers() {
    if (document.querySelector('.js-favorite-trigger')) {
        for (const favoriteTrigger of document.querySelectorAll('.js-favorite-trigger')) {
            if (favoriteTrigger.classList.contains('is-initialized')) {
                continue;
            }

            const favApp = Object.assign({}, FavoriteTriggerApp)
            favApp.initialize(favoriteTrigger)

            favoriteTrigger.classList.add('is-initialized')
        }
    }
}

initializeFavoriteTriggers();

Event.on('Listing.fetchedData', function (data) {
    initializeFavoriteTriggers();
})
